export default __webpack_public_path__ + "static/media/success.341a64bb.png";